// extracted by mini-css-extract-plugin
export default {"container":"SettingsSidebar_container__7L2bm","menuButton":"SettingsSidebar_menuButton__1Q12B","active":"SettingsSidebar_active__aamrN"};